<template>
  <div>
    <div class="bg pic-full"></div>
    <!-- <warn class="warn" :home-lang="home"></warn> -->
    <div class="home">
      <header>
        <head-nav-bar class="head-nav-bar" :home-lang="home"></head-nav-bar>
        <head-nav-bar-mini
          class="head-nav-bar-mini"
          :home-lang="home"
        ></head-nav-bar-mini>
      </header>
      <main class="fee-main">
        <fee-content class="fee-content" :home-lang="home"></fee-content>
      </main>
      <footer>
        <foot-content class="foot-content" :home-lang="home"></foot-content>
      </footer>
    </div>
  </div>
</template>

<script>
import home from "@/lang/en/home";
import Warn from "@/components/contents/warn";
import HeadNavBar from "@/components/Layouts/HeadNavBar";
import FootContent from "@/components/Layouts/FootContent";
import HeadNavBarMini from "@/components/Layouts/HeadNavBarMini";
import FeeContent from "@/components/fee/feeContent";

export default {
  name: "Fee",
  components: {
    Warn,
    FeeContent,
    HeadNavBar,
    HeadNavBarMini,
    FootContent,
  },
  data() {
    return {
      home: home,
    };
  },
};
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .fee-main {
    width: 8.33rem;
    margin: 0 auto;
    margin-top: 0.59rem;
    position: relative;
  }
}
@media screen and (max-width: 767px) {
  .fee-main {
    margin-bottom: 0.3rem;
  }
}
</style>
